export default __webpack_public_path__ + "/dist/images/shipping-icon.5288d661580319d3def5264418647c06.svg";